import { render } from "./CvDocument.vue?vue&type=template&id=6491bf30"
import script from "./CvDocument.vue?vue&type=script&lang=js"
export * from "./CvDocument.vue?vue&type=script&lang=js"

import "./CvDocument.vue?vue&type=style&index=0&id=6491bf30&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__